<template>
    <div>
        <vue-headful title="Subcontractor Approvals :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/subcontractors`">
                        <i class="fa fa-address-book-o"></i> Subcontractors
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Approvals
                </li>
            </ol>
        </h4>

        <sub-approvals-list></sub-approvals-list>
    </div>
</template>

<script>
    export default {

        data: function() {

        },

        methods: {

        },
    }
</script>
